/*
 * Media Showcase, trois roles :
 *   1. caler la hauteur du panneau place en haut de page ;
 *   2. ne telecharger les videos de fond qu'au moment utile ;
 *   3. faire avancer le travelling sur les navigateurs sans animation-timeline.
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------------------------------------------------------
   * 1. Hauteur exacte du panneau de tete
   *
   * --header-height ne couvre que l'en-tete : la barre d'annonce, elle,
   * n'y figure pas. On mesure donc la distance reelle entre le haut du
   * document et la section, ce qui reste juste quel que soit ce qui la
   * precede et a toutes les largeurs d'ecran.
   * ------------------------------------------------------------- */

  var toFit = document.querySelectorAll('.media-showcase__panel--first');

  function fitPanels() {
    for (var i = 0; i < toFit.length; i++) {
      var panel = toFit[i];
      // On neutralise l'offset avant de mesurer, sinon on mesurerait une
      // position deja corrigee au redimensionnement suivant.
      panel.style.setProperty('--showcase-offset', '0px');
      var top = panel.getBoundingClientRect().top + window.pageYOffset;
      panel.style.setProperty('--showcase-offset', Math.max(0, Math.round(top)) + 'px');
    }
  }

  if (toFit.length) {
    fitPanels();
    // La hauteur de l'en-tete change avec la largeur (menu qui se replie),
    // et apres le chargement des polices.
    window.addEventListener('resize', debounce(fitPanels, 150));
    window.addEventListener('load', fitPanels);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitPanels);
  }

  /* ---------------------------------------------------------------
   * 2. Videos de fond
   * ------------------------------------------------------------- */

  function sourceFor(video) {
    var mobile = video.dataset.srcMobile;
    var desktop = video.dataset.srcDesktop;
    // 750px correspond au point de rupture mobile du theme.
    if (window.innerWidth <= 750 && mobile) return mobile;
    return desktop || mobile;
  }

  function load(video) {
    if (video.dataset.loaded === 'true') return;
    var src = sourceFor(video);
    if (!src) return;
    video.dataset.loaded = 'true';
    video.src = src;
    video.load();
  }

  function play(video) {
    // Sous "mouvement reduit", on laisse l'image d'apercu et on ne lance rien.
    if (reducedMotion.matches) return;
    load(video);
    var attempt = video.play();
    if (attempt && typeof attempt.then === 'function') {
      attempt
        .then(function () {
          video.classList.add('is-playing');
        })
        .catch(function () {
          // Lecture refusee par le navigateur (economie de donnees, batterie
          // faible...). Le poster reste affiche : le rendu reste correct.
        });
    } else {
      video.classList.add('is-playing');
    }
  }

  function pause(video) {
    if (!video.paused) video.pause();
  }

  var videos = document.querySelectorAll('[data-showcase-video]');

  if (videos.length) {
    if ('IntersectionObserver' in window) {
      // Marge de 25% : la video commence a se charger juste avant d'etre
      // visible, pour qu'elle tourne deja quand on arrive dessus.
      var videoObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.isIntersecting ? play(entry.target) : pause(entry.target);
          });
        },
        { rootMargin: '25% 0px', threshold: 0.1 }
      );
      Array.prototype.forEach.call(videos, function (v) {
        videoObserver.observe(v);
      });
    } else {
      Array.prototype.forEach.call(videos, play);
    }

    // Un onglet en arriere-plan ne doit rien consommer.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) Array.prototype.forEach.call(videos, pause);
    });
  }

  /* ---------------------------------------------------------------
   * 3. Travelling : repli pour les navigateurs sans animation-timeline
   *
   * Sur Chrome et Edge recents, le CSS s'en charge seul et ce bloc ne
   * s'execute jamais. Ailleurs (Safari et Firefox plus anciens), on met a
   * jour --showcase-p a chaque image, mais uniquement pour les volets
   * effectivement a l'ecran.
   * ------------------------------------------------------------- */

  var nativeTimeline =
    window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()');

  if (!nativeTimeline && !reducedMotion.matches && 'IntersectionObserver' in window) {
    var moving = document.querySelectorAll(
      '.media-showcase[data-motion]:not([data-motion="none"]) .media-showcase__panel'
    );

    if (moving.length) {
      var visible = [];
      var ticking = false;

      function frame() {
        var vh = window.innerHeight;
        for (var i = 0; i < visible.length; i++) {
          var rect = visible[i].getBoundingClientRect();
          // Meme progression que "animation-range: cover 0% cover 100%" :
          // 0 quand le volet entre par le bas, 1 quand il sort par le haut.
          var p = (vh - rect.top) / (vh + rect.height);
          visible[i].style.setProperty('--showcase-p', clamp(p).toFixed(4));
        }
        ticking = false;
      }

      function request() {
        if (ticking || !visible.length) return;
        ticking = true;
        window.requestAnimationFrame(frame);
      }

      var motionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var at = visible.indexOf(entry.target);
          if (entry.isIntersecting && at === -1) visible.push(entry.target);
          else if (!entry.isIntersecting && at !== -1) visible.splice(at, 1);
        });
        request();
      });

      Array.prototype.forEach.call(moving, function (panel) {
        motionObserver.observe(panel);
      });

      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
      request();
    }
  }

  /* --------------------------------------------------------------- */

  function clamp(n) {
    return n < 0 ? 0 : n > 1 ? 1 : n;
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }
})();
